import { QuestionAnswer } from './question-answer';
import { Identifiable } from './identifiable';
import { Question } from './question';
import { AssessmentFactorSelection } from './assessment-factor-selection';

export class Answer extends Question {
  questionAnswer: QuestionAnswer;
  rank: number;
  impact: number;
  probability: number;
  impactWeight: number;
  probabilityWeight: number;
  factors: Array<AssessmentFactorSelection>;
  skip: boolean;
  comments: string;
  parent: Identifiable; // Answer
}
